import classNames from 'classnames';
import Button from 'components/generics/buttons/Button';
import { HTMLAttributes, useState } from 'react';
import classes from './index.module.scss';

export type MultiChoiceButton = {
  value: string;
  text: string;
  onClick?: () => void;
};

interface Props extends HTMLAttributes<HTMLDivElement> {
  buttons: MultiChoiceButton[];
  buttonClassName?: string;
  selectedButtonClassName?: string;
  onChangeValues?: (values: string[]) => void;
}

const MultiChoiceButtons = ({
  buttons,
  buttonClassName,
  selectedButtonClassName,
  className,
  onChangeValues,
}: Props) => {
  const [selectedValues, setSelectedValues] = useState<string[]>([]);

  const onClickButton = (value: string) => {
    setSelectedValues((prev) => {
      let newValues = [...prev];
      if (newValues.indexOf(value) > -1) {
        newValues = newValues.filter((e) => e !== value);
        onChangeValues && onChangeValues(newValues);
      } else {
        newValues.push(value);
        onChangeValues && onChangeValues(newValues);
      }
      return newValues;
    });
  };

  return (
    <div className={classNames(classes.container, className)}>
      {buttons.map(({ value, text, onClick }, index) => (
        <Button
          key={value}
          onClick={() => {
            onClickButton(value);
            onClick && onClick();
          }}
          className={classNames(
            buttonClassName,
            selectedValues.indexOf(value) > -1 && selectedButtonClassName
          )}
        >
          {text}
        </Button>
      ))}
    </div>
  );
};

export default MultiChoiceButtons;
